exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.push([module.id, "@import url(http://fonts.googleapis.com/css?family=Roboto);", ""]);

// module
exports.push([module.id, "auth{display:flex;flex:1;width:100%;height:100%;justify-content:center;align-items:flex-start}auth .auth{margin-top:64px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/auth/auth.scss
// module id = 578
// module chunks = 0